import { detect } from 'detect-browser';
import env from '../../env';
import chrome from '../../Assets/Platforms/chrome.png';

const userAgentContains = (str: string) =>
  navigator.userAgent.match(new RegExp(str, 'i'));

const isIOS = userAgentContains('iPad|iPhone|iPod');
const isAndroid = userAgentContains('android');
const isMac = userAgentContains('Macintosh|MacIntel|MacPPC|Mac68K');
const isPC = userAgentContains('Windows|Win32|Win64|WOW64');

const iosDownloadUrl = 'https://apps.apple.com/gb/app/kindred-app/id1468277090';
const androidDownloadUrl =
  'https://play.google.com/store/apps/details?id=com.kindredsoul.kindredapp';

const MOBILE_OS = [
  'iOS',
  'Android OS',
  'BlackBerry OS',
  'Windows Mobile',
  'Amazon OS',
];

const platform = {
  platform: 'chrome',
  logo: chrome,
  link: env.chrome_extension_store_url,
};

const isMobile = () => {
  const browser = detect();
  return !!browser?.os && MOBILE_OS.includes(browser?.os);
};

const getBrowserName = () => {
  return detect()?.name;
};

export const getPlatform = () => {
  return platform;
};

export {
  isIOS,
  isAndroid,
  isMac,
  isPC,
  iosDownloadUrl,
  androidDownloadUrl,
  isMobile,
  getBrowserName,
};
